import dayjs from 'dayjs';
import { API_ENDPOINTS } from '../../constants/apiEndpoints';
import { ENVIRONMENT_CONFIG } from '../../constants/environmentConfig';
import fetcher from '../../helpers/fetcher';
import { unwrapDataResponse } from '../../utils/unwrapDataResponse';
import { referenceDataSyncService } from '../../services/referenceDataSyncService';

export const getMarketPulseData = async () => {
  try {
    let res: {
      avgFoodPrice?: any;
      inflationData?: any;
      deflationData?: any;
      noOfInspectionsData?: any;
    } = {};

    const date = dayjs();
    const startOfWeek = date.add(-7, 'day').startOf('day');
    const endOfWeek = date.endOf('day');
    const basicFoodBasketId = await referenceDataSyncService.getBasicFoodBasketId();

    if (!basicFoodBasketId) {
      return res;
    }
    // const startOfTwoWeek
    const [avgFoodPriceRes, inflationRes, deflationRes, noOfInspectionsRes] =
      await Promise.allSettled([
        fetcher.get(
          API_ENDPOINTS.ANALYSIS.GET_PUBLIC_PRICE_AVERAGE,
          {
            basketId: basicFoodBasketId,
            startTime: startOfWeek.valueOf(),
            endTime: endOfWeek.valueOf(),
          },
          {},
          ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
        ),
        fetcher.get(
          API_ENDPOINTS.ANALYSIS.GET_PUBLIC_PRICE_CHANGE,
          {
            type: 'inflation',
            limit: 2,
            basketId: basicFoodBasketId,
            startTime: startOfWeek.valueOf(),
            endTime: endOfWeek.valueOf(),
          },
          {},
          ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
        ),
        fetcher.get(
          API_ENDPOINTS.ANALYSIS.GET_PUBLIC_PRICE_CHANGE,
          {
            type: 'deflation',
            limit: 2,
            basketId: basicFoodBasketId,
            startTime: startOfWeek.valueOf(),
            endTime: endOfWeek.valueOf(),
          },
          {},
          ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
        ),
        fetcher.get(
          API_ENDPOINTS.INSPECTION.GET_PUBLIC_INSPECTION_COUNT,
          {
            startTime: startOfWeek.valueOf(),
            endTime: endOfWeek.valueOf(),
            basketId: basicFoodBasketId,
          },
          {},
          ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
        ),
      ]);

    if (avgFoodPriceRes.status === 'fulfilled') {
      res = {
        avgFoodPrice: unwrapDataResponse(
          (avgFoodPriceRes as PromiseFulfilledResult<any>).value.data
        ),
      };
    }

    if (inflationRes.status === 'fulfilled') {
      res = {
        ...res,
        inflationData: unwrapDataResponse((inflationRes as PromiseFulfilledResult<any>).value.data),
      };
    }

    if (deflationRes.status === 'fulfilled') {
      res = {
        ...res,
        deflationData: unwrapDataResponse((deflationRes as PromiseFulfilledResult<any>).value.data),
      };
    }

    if (noOfInspectionsRes.status === 'fulfilled') {
      res = {
        ...res,
        noOfInspectionsData: unwrapDataResponse(
          (noOfInspectionsRes as PromiseFulfilledResult<any>).value.data
        ),
      };
    }

    return res;
  } catch (error: any) {
    throw error;
  }
};
